const map = {
	"./Batch_Production_Record_2388-OXB-A-1.docx": 68725,
	"./Batch_Production_Record_2785-OXB-B-1.docx": 15735,
	"./CoA_2388-OXB-A-1.docx": 34620,
	"./CoA_2785-OXB-B-1.docx": 45666,
	"./Deviation_Report_DEV-5842_2388-OXB-A-1.docx": 13217,
	"./Deviation_Report_DEV-5970_2785-OXB-B-1.docx": 63965,
	"./Investigation_Report_IR-OXB-2388-001_2388-OXB-A-1.docx": 71276,
	"./Investigation_Report_IR-OXB-2785-001_2785-OXB-B-1.docx": 69471,
	"./Planned_Change_Request_PC-OXB-2388-092_2388-OXB-A-1.docx": 60970,
	"./Planned_Change_Request_PC-OXD-2785-121_2785-OXB-B-1.docx": 18948
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28323;